import React from 'react';
import styled from 'styled-components';

import EmbedIcon from '../Assets/embed.svg';
import InfoIcon from '../Assets/info.svg';
import TwitterIcon from '../Assets/twitter.svg';
import FacebookIcon from '../Assets/facebook.svg';

import { getHrefFb, getHrefTw } from './ShareUtils';
import { media } from '~/styles/Utils';

const SharingWrapper = styled.div`
  ${media.m`
  display: flex;
  `}
`;

const SharingButton = styled.div`
  color: ${(props) => props.theme.colors.greyblue};
  text-transform: uppercase;
  font-size: 12px;
  margin-right: 10px;
  font-weight: 700;
  cursor: pointer;
  display: flex;
  align-items: center;
  user-select: none;
  position: relative;
  &:hover {
    color: ${(props) => props.theme.colors.darkblue};
    fill: ${(props) => props.theme.colors.darkblue};
  }
`;

const SharingButtonLabel = styled.div`
  margin-left: 4px;
`;

const SharingLink = styled.a.attrs({
  target: '_blank',
})`
  margin-right: 5px;
  top: 2px;
  position: relative;
  &:hover {
    opacity: 0.9;
  }
`;

const ShareLinkWrapper = styled.div``;

export default ({ setInfoboxContent }) => (
  <SharingWrapper>
    {/* <SharingButton onClick={() => setInfoboxContent('faq')}>
      <InfoIcon width={10} height={11} />
      <SharingButtonLabel>Info</SharingButtonLabel>
    </SharingButton> */}
    <SharingButton onClick={() => setInfoboxContent('embed')}>
      <EmbedIcon width={10} height={11} />
      <SharingButtonLabel>Einbetten</SharingButtonLabel>
    </SharingButton>
    <ShareLinkWrapper>
      <SharingLink href={getHrefTw()}>
        <TwitterIcon style={{ fill: '#1da1f2' }} width={18} />
      </SharingLink>
      <SharingLink href={getHrefFb()}>
        <FacebookIcon style={{ fill: '#3b5998' }} width={18} />
      </SharingLink>
    </ShareLinkWrapper>
  </SharingWrapper>
);
